// ============================================================================
// ProgressRing — anneau de progression des sondages (L10, F-163)
// ============================================================================
// Composant LOCAL a gest : le parc n'a pas d'anneau dans @gs/ui (il a
// GsProgressBar, lineaire) et le MASTER interdit de toucher packages/ui. S'il
// devient un besoin d'une 2e app, il montera en @gs/ui via NEW_COMPONENT.skill.md.
// SVG pur, tokens DS (currentColor + classes de couleur — aucun hex en dur),
// dark-aware par les tokens (regle #28 : AUCUNE rustine dark).

export function ProgressRing({
  value,
  max,
  label,
  size = 84,
}: {
  value: number;
  max: number;
  /** Texte central (deja i18n par l'appelant — jamais de t() dans un presentational). */
  label: string;
  size?: number;
}) {
  const safeMax = max > 0 ? max : 1;
  const ratio = Math.min(1, Math.max(0, value / safeMax));
  const stroke = 8;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = Math.round(ratio * 100);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        role="img"
        aria-label={label}
        // -rotate-90 : depart a midi plutot qu'a 3h (convention des anneaux).
        className="-rotate-90"
      >
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" strokeWidth={stroke}
          className="stroke-slate-200 dark:stroke-slate-700"
        />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" strokeWidth={stroke} strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - ratio)}
          className="stroke-brand-500 transition-[stroke-dashoffset] duration-500"
        />
      </svg>
      <span className="absolute text-meta font-semibold tabular-nums text-slate-900 dark:text-slate-100">
        {pct}%
      </span>
    </div>
  );
}
